import { isNotEmpty } from "./langUtils";

// Endress & Hauser internal users have an @endress.com email. Case-insensitive
// because SSO providers sometimes preserve the casing the user typed.
export function isInternalUser(email: string | null | undefined): boolean {
  return !!email?.toLowerCase().endsWith("@endress.com");
}

export function displayUserName(
  user: $TSFixMe,
  fallbackWithEmail = false,
  useRawLabels = false,
) {
  if (!user) {
    return null;
  }

  if (
    useRawLabels &&
    (isNotEmpty(user.first_name) || isNotEmpty(user.last_name))
  ) {
    return `${user.first_name ? user.first_name : ""} ${user.last_name ? user.last_name : ""}`.trim();
  }
  if (
    !useRawLabels &&
    (isNotEmpty(user.firstName) || isNotEmpty(user.lastName))
  ) {
    return `${user.firstName ? user.firstName : ""} ${user.lastName ? user.lastName : ""}`.trim();
  }

  if (fallbackWithEmail) {
    return user.email;
  }

  return null;
}
